import { render, staticRenderFns } from "./RaceClassAlignmentFields.vue?vue&type=template&id=4e6e759d"
import script from "./RaceClassAlignmentFields.vue?vue&type=script&lang=js"
export * from "./RaceClassAlignmentFields.vue?vue&type=script&lang=js"
import style0 from "./RaceClassAlignmentFields.vue?vue&type=style&index=0&id=4e6e759d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports